<template>
  <div class="service">
    <div class="empty" style="height: 100px;"></div>
      <div class="page_width">
        <div class="page_title ">
            <div class="color1 text-l fs-f80">Privacy Policy</div>
            <div class="title_tag color1 text-l">Last Updated: September 17, 2025</div>
        </div>
        <h3 class="title_big">Introduction</h3>
 
        <div class="text_msg">This Privacy Policy explains how CorelinkPay ("we," "us," or "our") collects, uses, discloses, and protects your personal information when you visit our website txalmxj.com (the "Website") or use our services. We are committed to safeguarding your privacy and ensuring that your personal information is handled responsibly.</div>

        <h3 class="title_big">Information We Collect</h3>
        <div class="text_msg color1">We may collect the following types of information: </div>
        <div class="text_msg">Personal Information </div>
        <div class="text_msg">Contact Information: Name, email address, phone number, or other details you provide when you register, contact us, or subscribe to our services.</div>
        <div class="text_msg">Account Information: Username, password, and other details used to access your account.</div>
         
        <div class="text_msg"> Payment Information: Billing details, such as credit card information, processed through secure third-party payment processors.</div>
        <div class="text_msg">Non-Personal Information</div>
        
        <div class="text_msg">Usage Data: Information about how you interact with our Website, including IP address, browser type, device information, pages visited, and time spent on the Website.</div>
        <div class="text_msg">Cookies and Tracking Technologies: We use cookies, web beacons, and similar technologies to enhance your experience, analyze usage, and deliver personalized content.</div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>
        <div class="text_msg"> </div>





        <h3 class="title_big">How We Use Your Information</h3>
        <div class="text_msg color1">We use the information we collect to:</div>
        <div class="text_msg">Provide, maintain, and improve our Website and services. 
          <br>
          Process transactions and fulfill orders. <br>
          Send you updates, newsletters, or promotional materials (with your consent). <br>
          Respond to your inquiries or provide customer support. <br>
          Analyze Website usage to improve functionality and user experience.<br>
          Comply with legal obligations and protect our rights.
        
        </div>
       
     

        <h3 class="title_big">How We Share Your Information</h3>
        <div class="text_msg color1" >We do not sell or rent your personal information. We may share your information with:</div>
        <div class="text_msg"> Service Providers: Third parties that perform services on our behalf, such as hosting, payment processing, or analytics, under strict confidentiality agreements.  </div>
        <div class="text_msg"> Legal Compliance: When required by law, such as in response to a subpoena or court order.</div>
        <div class="text_msg"> Business Transfers: In connection with a merger, acquisition, or sale of assets, your information may be transferred to the acquiring entity.</div>
        
        <h3 class="title_big">Your Choices</h3>
        <div class="text_msg">Cookies: You can manage cookie preferences through your browser settings. </div>
        <div class="text_msg">Marketing Communications: You may opt out of receiving promotional emails by following the unsubscribe instructions in those emails.</div>
        <div class="text_msg">Account Information: You can update or delete your account information by contacting us at business@corelinkpay.net.</div>

        <h3 class="title_big"></h3>
        <div class="text_msg"></div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>


        <h3 class="title_big">Data Security</h3>
        <div class="text_msg">We implement reasonable technical and organizational measures to protect your personal information from unauthorized access, loss, or misuse. However, no system is completely secure, and we cannot guarantee absolute security.</div>
        <div class="text_msg"></div>

        <h3 class="title_big">Third-Party Links</h3>
        <div class="text_msg">Our Website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites. We encourage you to review their privacy policies.</div>
  
        <div class="text_msg"> </div>
        <div class="text_msg"></div>

   

        <h3 class="title_big">Children's Privacy</h3>
        <div class="text_msg">Our Website is not intended for individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us at business@corelinkpay.net.</div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>
        <h3 class="title_big">International Users</h3>
        <div class="text_msg">Your information may be transferred to and processed in Hong Kong. By using the Website, you consent to such transfer.</div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>

        <h3 class="title_big">Changes to This Privacy Policy</h3>
        <div class="text_msg">We may update this Privacy Policy from time to time. The updated version will be posted on this page with a revised "Last Updated" date. We encourage you to review this policy periodically.</div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>
        <h3 class="title_big">Contact Us</h3>
        <div class="text_msg">If you have questions or concerns about this Privacy Policy, please contact us at:  </div>
        <div class="text_msg">Email: business@corelinkpay.net  </div>
        <div class="text_msg">Address: 
Room 1208-1209, Shenzhen Center Business Building
West Mintian Road, Futian Central District
Futian District, Shenzhen, China</div>
       
        <h3 class="title_big"></h3>
        <div class="text_msg"></div>
        <div class="text_msg"> </div>
        <div class="text_msg"></div>
      

       
      </div>

      


  </div>
</template>

<script>

export default {
  data(){
      return{

      }
  },
  methods:{
     goTop(e){
      document.querySelector(e).scrollIntoView(true);
    }
  },
  created(){
   
  }

}
</script>

<style scoped>

</style>